import { SITES } from '../../../../constants';

export const initialState = {
  summaryResult: [],
  selectedDate: new Date(),
  code: '',
  name: '',
  statusId: 1,
  statusResult: [],
  setStatusResult: [],
  eid_Lockdown: SITES.DETAILS.anyDefaultVal, // You can store the eid_Lockdown id here
  eid_LockdownName: SITES.DETAILS.inputModalDefaultVal, // You can store the eid_LockdownName here
  voyix_Owned: SITES.DETAILS.anyDefaultVal, // You can store the voyix_Owned id here
  voyix_OwnedName: SITES.DETAILS.inputModalDefaultVal, // You can store the voyix_OwnedName here
  disableObject: {
    isDate: false,
    isStatus: false,
    isCode: false,
    isName: false,
  },
  activeSearch: {
    siteId: 0,
    effectiveDate: '',
    statusId: 1,
    eid_Lockdown: null,
    voyix_Owned: null,
    serviceProductCode: '',
    serviceProductName: '',
  },
};
